/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unknown-property */
/* eslint-disable import/exports-last */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React, { useContext, useEffect } from 'react'
import { useDisclosure } from '@chakra-ui/react'
import { css } from '@emotion/react'
import { GatsbyImage } from 'gatsby-plugin-image'
import ImageGallery from 'react-image-gallery'
import { jsx } from 'theme-ui'
import { BorderButton } from '../../components/button'
import { Box, Col, FlexGrid, Heading } from '../../components/elements'
import PreviewCompatibleImg from '../../components/PreviewCompatibleImage'
import { withVSensor } from '../../components/VSensor'
import InterfaceContext from '../../context/interface'
import useGallery from '../../hooks/useGallery'
import { RedRoof } from '../WhyUs/WhyUs.styles'
import 'react-image-gallery/styles/css/image-gallery.css'

export const Roof = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="204px"
    height="45px"
    {...props}
  >
    <image
      x="0px"
      y="0px"
      width="204px"
      height="45px"
      href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAAAtCAQAAABIM0xeAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfjCxESMAuUR1oCAAAFC0lEQVR42u2beWxUVRTGv2lLC5Q2yJ4gCFSQKCBWMRiWoAgiEIiyK1DaiisBBUMwcQNxDUECRiWhZQBlk4IRBKMgiooS0SAiKAEJyCJRkEWw2DI//8AQLPSdmWE6d17r+f6aeXc553znzb333DMBVAkkQ0OUr+Z6S4Xa7lqZ2EjA98R0UZ4Gq+b5z5sU1CIdd63W5YqfiWmkHOWp1SWeFKtIQX2skGsVoxd/EpOi3spXHyV7ttqr+ZqrPa6VjU78R0wr5StHDcNuv15BLdNp12pHKn4iJl2DlafOUfQ8qaUq1EbXBkQifiGmo/I1RBmebUqV4vn8JwU1T4dcmxKmkOioz3h+wFt+ZwZtyeR+vjJanmUVA0l1bpUJ5wp4IJneFPG3p6NDfMAg0i7o1ZpXOGQSOZP2zu3zJTFZTGW/4d49PE3TS/ZOoS/LDUrhW8ZS17mlviGmBsNZb7i0mEV0J8kYqR6P8p0x0hmW0Ztk51YnODE38gbHzDgfwxURjJnNLI4YYx7gJVo5tz4hianLWDO6/+A1sqMaPY3BrOGsMf7n3EeGc08kDDFJ9GAxZzxdFmId91D9MmdqzBPsNMg5xXy6EXDuFcfEXMWz7DVc9QtTaB6zGQN0poCTxpy7y91WVHpi0hjKR4Q83XOGd+hlLvHRIJ0cPjXICbE2Bm+pr4i5npnmcvw9j1GvgvXI4jn2GXoc401urvzE1OYhvjFccYLZdIibRkn0YCHFhk7beJyG8SUmXrmygG5VngaoumerDSpwkgmurWHKVQfPNqVao0K9r5Jynq9SrXL7dotCpziwfyVPstuIyYO8yNXxjcmL0IZpHDb0PMx02lyyt9f5KwptKtbUVAaw2jg/lLCCvglz9q5Gf96lxKBnMw9T26/EXMd0fjMM3BH/3+6w0JDxbDN0L2YxPS/YM/qAmExGm+n3kxTQyTkB3ujA62aCaB9TyUp8YgJ0YS6nDGO+IJ9azt0eHqozlA+N8xZsYJTnoTWKmWO3K2ukHOWrpWebw1qgAv0YqynjJk01UrlqEXX/QBR9YhBVKfTnPUo9Y6qUldxFNedvwOX8GnQlyJ9EIw7emGuUZ9as7FKhgr65a/eWDA1SnjpF2Cuub0w6uXxmRMpp5tE1EXK1MUZLXjDvV50s/rcwx8zQbuIBMp27sOKQTC+WGtcVcSSmARPCqFl5lbbOHRcf1GGMmf2DFfSLdH2NJEL6UGSciUOs8UdxUIzRjhnmYfpXpnFtrInJ4nkOGBP/zFM0ce4id0jlblYae1PYxIMXJXOiIqYmI8KoWXmb7pVwiY8GjZjIDsNff7GQ260LQK+HN4VVs/JIeBFQpdCR2Rw3PLeXKbSIlJi6jGWrMfBRZnGDcxckLmownHVmMucTRpIeDjFJ9GSJWbOylmHubsN9hWY8wx6DnBPMuTih+99BJps1K/uYTDPn5voLAW5jAacNz+5kEo3LEpPGUNaaNStLuKNCalaqBjIZzUaDnLOsZuC5EnnRnlkcNTpsZVyF16xUDbTmZfO/CEeYSXaAXcrySKWd0CLN0WbXucNKJcm6U6PUT9U82uwWEz12DCOo6TzGKivqMY4t5fp+YoD62q/UMnwdVFBztct1aFUBydYo3as6Zb4tVRMhFl7AVAnL6ZMwNStVA2kMLFNLVHRuV9bt34/bmUAD52pWVTRm0vn/IvQ8d4MZ0NfaogJ96fq9/l/USbnqqHYK/QNNZVk2EeAPmAAAAABJRU5ErkJggg=="
    />
  </svg>
)

const Gallery = ({ bottomText, headertext, title, bottombg, ...props }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line func-names
      document.onkeydown = function (evt) {
        let isEscape = false
        if ('key' in evt) {
          isEscape = evt.key === 'Escape' || evt.key === 'Esc'
        } else {
          isEscape = evt.keyCode === 27
        }
        if (isEscape) {
          onClose()
        }
      }
    }
  })

  const photos = useGallery()
  const galleryPhotos = photos.map(
    ({
      localFile: {
        childImageSharp: { gatsbyImageData },
      },
    }) => {
      return {
        renderItem: () => (
          <Box width="100%">
            <GatsbyImage image={gatsbyImageData} />
          </Box>
        ),
        renderThumbInner: () => <GatsbyImage sx={{ height: 100 }} image={gatsbyImageData} />,
      }
    },
  )

  const { isDesktopViewport } = useContext(InterfaceContext)
  return (
    <>
      <Box {...props}>
        <Box sx={{ textAlign: 'center', py: [3, 4], bg: 'muted' }}>
          <Col mx="auto">
            <RedRoof sx={{ mx: 'auto' }} />
            <Heading color="primary" sx={{ fontSize: [3, 3, 4], mt: 2 }}>
              {title}
            </Heading>
            <Heading color="black" sx={{ fontSize: [5, 5, 6, 7] }}>
              {headertext}
            </Heading>
          </Col>
        </Box>
        <FlexGrid sx={{ alignItems: 'stretch' }}>
          {photos.slice(0, isDesktopViewport ? 8 : 4).map(
            (image, i) =>
              image && (
                <Box
                  // eslint-disable-next-line react/no-array-index-key
                  key={i}
                  onClick={onOpen}
                  width={[1 / 2, null, null, 1 / 4]}
                  sx={{ cursor: 'pointer' }}
                >
                  <PreviewCompatibleImg
                    image={image}
                    sx={{ height: [200, 240, 260, 280] }}
                    objectFit="cover"
                  />
                </Box>
              ),
          )}
        </FlexGrid>
        <div
          css={css`
            display: grid;
          `}
        >
          <GatsbyImage
            css={css`
              grid-area: 1/1;
            `}
            alt=""
            image={bottombg.localFile.childImageSharp.gatsbyImageData}
          />
          <div
            css={css`
              grid-area: 1/1;
              position: relative;
            `}
          >
            <Col mx="auto" py={[4, 5]}>
              <Roof sx={{ mx: 'auto' }} />
              <Heading fontSize={[4, 5, 6]} maxWidth={900} textAlign="center" my={3} color="white">
                View all Residential Roofs by Phil DiBello Family Roofing Maryland
              </Heading>
              {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
              <p onClick={onOpen}>
                <BorderButton
                  textColor="primary"
                  color="white"
                  fontSize={[3]}
                  text="View All"
                  width={200}
                  zIndex={1}
                />
              </p>
            </Col>
          </div>
        </div>
      </Box>
      <div
        css={css`
          ${isOpen === true
            ? `position: fixed; top: 0; bottom: 0; left: 0; right: 0; z-index: 2;`
            : `display: none;`}
        `}
      >
        <div
          onClick={onClose}
          css={css`
            position: fixed;
            background: rgba(0, 0, 0, 0.58);
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
          `}
        />
        <div
          css={css`
            @media (min-width: 992px) {
              max-width: 90%;
            }
          `}
          sx={{
            my: 6,
            width: '100%',
            bg: 'white',
            mx: 'auto',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '10',
          }}
        >
          <Box>
            <ImageGallery items={galleryPhotos} lazyLoad />
          </Box>
        </div>
      </div>
    </>
  )
}

Gallery.propTypes = {}

Gallery.defaultProps = {
  bottomText: 'View all Residential Roofs by Phil DiBello \r\nFamily Roofing Maryland',
  fieldGroupName: 'page_Flexpage_PageBuilder_ProjectPhotoGallery',
  bottombg: {
    sourceUrl:
      'https://wordpress-321502-1056842.cloudwaysapps.com/wp-content/uploads/2019/11/Layer-814.png',
  },
  headertext: 'Photo Gallery',
  title: 'Phil DiBello Family Roofing',

  projects: [
    {
      id: 'cHJvamVjdDoyNjA=',
      project: {
        title: 'Project n4',
        location: 'Another Place, MD',
      },
      slug: 'fourth-project',
      featuredImage: {
        sourceUrl:
          'https://wordpress-321502-1056842.cloudwaysapps.com/wp-content/uploads/2019/11/Layer-929.png',
      },
    },
    {
      id: 'cHJvamVjdDoyNTk=',
      project: {
        title: 'Third Project',
        location: 'Somewhere, PA',
      },
      slug: 'third-project',
      featuredImage: {
        sourceUrl:
          'https://wordpress-321502-1056842.cloudwaysapps.com/wp-content/uploads/2019/11/Layer-932.png',
      },
    },
    {
      id: 'cHJvamVjdDoyNTg=',
      project: {
        title: 'Another Project',
        location: 'Bellaire',
      },
      slug: 'another-project',
      featuredImage: {
        sourceUrl:
          'https://wordpress-321502-1056842.cloudwaysapps.com/wp-content/uploads/2019/11/Layer-934.png',
      },
    },
    {
      id: 'cHJvamVjdDoyNTc=',
      project: {
        title: 'Residential Roof',
        location: 'Philadelphia, PA',
      },
      slug: 'residential-roof',
      featuredImage: {
        sourceUrl:
          'https://wordpress-321502-1056842.cloudwaysapps.com/wp-content/uploads/2019/11/Layer-933.png',
      },
    },
  ],
}

export default withVSensor(Gallery)
